module.exports = __webpack_public_path__ + "static/media/kv-ko.b7a2848a.jpg";